import { PlusCircleOutlined } from '@ant-design/icons'
import { MemberProps } from 'app/components/Core/convention'
import Button from 'app/components/UI-Elements/General/Button'
import Restricted from 'app/components/UI-Elements/General/Restricted'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useRentalCreate } from 'app/lib/hooks/useRentalCreate'
import * as React from 'react'

interface Props extends React.ComponentProps<typeof Button> {
  onSuccess?: (rental: IRental) => void
}

const RentalCreateButton: React.FC<MemberProps<Partial<IRental>, Props>> = ({
  member,
  props: { onSuccess, ...others } = {}
}) => {
  const { tButtonTitle } = ToolBox.useString()
  const { createRental, loading } = useRentalCreate()

  return (
    <Restricted allowFor={['admin', 'manager', 'member']}>
      <Button
        type="secondary"
        title={tButtonTitle({ recordType: RecordType.rental, action: 'create' })}
        onClick={() => createRental(member, onSuccess)}
        loading={loading}
        icon={<PlusCircleOutlined />}
        {...others}
      />
    </Restricted>
  )
}

export default RentalCreateButton
